export default {
  title: {
    id: 'review_ai_summary_filters_title',
    defaultMessage: 'Filter by top mentions',
  },
} as const
